import React, { Component } from 'react';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import axios from '../../axios-ns';
import Aux from '../../hoc/Aux';
import * as messages from '../../messages';

class OptIn extends Component {
    state = {
        error: null,
        loading: false,
        controls: {
            firstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'input',
                    placeholder: 'Twoje imię'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: false
                },
                touched: false,
            },
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'input',
                    placeholder: 'Twój adres email'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                touched: false
            }
        }
    };

    componentDidMount() {
        this.setState({ ...this.state, loading: true });

        axios.get('/agreements')
            .then(response => {
                response.data.forEach(a => {
                    let required = a.required == '1' ? true : false;

                    this.setState({
                        ...this.state, controls: {
                            ...this.state.controls,
                            [a.agreementCode]: {
                                elementType: 'input',
                                labelStyle: { fontSize: '10px', textAlign: 'justify', marginTop: '-10px' },
                                elementConfig: {
                                    type: 'checkbox',
                                    label: (required ? '*' : '') + a.content
                                },
                                value: a.agreementCode,
                                validation: {
                                    required: required,
                                },
                                touched: false
                            }
                        }, loading: false
                    });
                })
            })
            .catch(err => {

            });
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                checked: event.target.checked,
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    isValid(controls) {
        let updatedControls = {
            ...this.state.controls,
        };

        let valid = true;

        for (let key in updatedControls) {
            const validation = updatedControls[key].validation;
            const value = updatedControls[key].elementConfig.type === 'checkbox' ? updatedControls[key].checked : updatedControls[key].value;

            if (validation.required && (!value || value === '')) {
                updatedControls[key].error = messages['ERR_REQUIRED'];
                valid = false;
            } else if (validation.minLength && validation.minLength > value.length) {
                updatedControls[key].error = messages['ERR_MINLENGTH'].replace('%', validation.minLength);
                valid = false;
            } else if (validation.isEmail && !this.isEmail(value)) {
                updatedControls[key].error = messages['ERR_ISEMAIL'];
                valid = false;
            } else if (validation.sameAs && value !== updatedControls[validation.sameAs].value) {
                updatedControls[key].error = messages['ERR_SAMEAS'].replace('%', messages[validation.sameAs.toUpperCase()]);
                valid = false;
            } else {
                updatedControls[key] = { ...updatedControls[key], error: null };
            }

        };

        this.setState({ controls: updatedControls });

        return valid;
    }

    isEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(String(email).toLowerCase());
    }

    submitHandler = (event) => {
        this.setState({ ...this.state, loading: true });
        event.preventDefault();

        if (!this.isValid(this.state)) {
            this.setState({ ...this.state, loading: false });
            return;
        }

        let signUpModel = {
            firstName: this.state.controls.firstName.value,
            email: this.state.controls.email.value,
            password: 'NaukaSpiewu2019',
            product: this.props.productCode,
            userToken: this.props.userToken,
            agreements: []
        };

        Object.keys(this.state.controls).filter(k => k.indexOf('rodo') >= 0 && this.state.controls[k].checked).forEach(k => {
            signUpModel['agreements'].push(this.state.controls[k].value);
        });

        this.signUp(signUpModel);
    }

    signUp = (signUpData) => {
        let url = 'register';

        axios.post(url, signUpData)
            .then(response => {
                this.setState({ ...this.state, loading: false, error: null });
                this.props.onSuccess();
            })
            .catch(err => {
                this.setState({ ...this.state, loading: false, error: err.response.data });
            });
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    labelStyle={formElement.config.labelStyle}
                    error={formElement.config.error}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let errorMessage = null;

        if (this.state.error) {
            errorMessage = (
                <p style={{ color: '#f50057' }}>{messages[this.state.error.message]}</p>
            )
        }

        let view = (
            <Card>
                <CardHeader title={this.props.header} className={classes.Head} />
                {errorMessage}
                <form onSubmit={this.submitHandler}>
                    {form}
                    <p style={{ textAlign: 'center' }}>
                        <Button color="primary" variant="contained" type="submit" variant="contained" type="submit" style={{ marginBottom: '35px', backgroundColor: 'orange', marginBottom: '35px' }}>
                            {this.props.buttonLbl}
                        </Button>
                    </p>
                </form>
            </Card>
        )

        if (this.state.loading) {
            view = <Spinner />
        }

        return (
            <Aux>
                {view}
            </Aux>
        )
    }
}

export default OptIn; 